import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import FilterGroupList from './containers/FilterGroupList';
import FilterGroupCreate from './containers/FilterGroupCreate';
import FilterGroupEdit from './containers/FilterGroupEdit';
import FilterGroupView from './containers/FilterGroupView';
import {
  SYSTEM_CONFIGURATION_ROUTE,
  FILTER_GROUP,
  FILTER_SETTING
} from '../../constants';

interface Props {
}

const FilterGroup: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTER_GROUP}`}>
        <FilterGroupList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTER_GROUP}/create`}>
        <FilterGroupCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTER_GROUP}/edit`}>
        <FilterGroupEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTER_GROUP}/view`}>
        <FilterGroupView />
      </Route>
    </Fragment>
  );
};

export default FilterGroup;
